<template>
  <button
    :class="
      `ml-1 box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black`
    "
    style="width:320px;"
    type="button"
    v-bind="$attrs"
  >
    <!-- v-show="!isRejectBtnEnabled" -->
    <div class="flex flex-row items-center justify-center">
      <ApprovedIcn width="20px" height="20px" class="mr-1" />
      <div class="flex flex-row items-baseline">
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          確認済
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`"
          >にする</span
        >
      </div>
    </div>
  </button>
</template>

<script>
// import { watch } from 'vue'
import ApprovedIcn from '@/assets/icons/approved-green.svg?inline'
// import { useRequestReject } from '@/services/politicalAction/useRequestReject'
// import { useResultReject } from '@/services/politicalAction/useResultReject'
// import { useReceiptReject } from '@/services/receipt/useReceiptReject'
// import { useMemoryReject } from '@/services/politicalAction/useMemoryReject'

export default {
  name: 'AppApproveBtn',

  components: {
    ApprovedIcn,
  },

  props: {
    color: String,
    docType: String,
  },

  // setup(props) {
  //   if (props.docType == 'request') {
  //     const { isRejectBtnEnabled, rejectedAttrs } = useRequestReject()
  //     watch(rejectedAttrs, () => {
  //       if (rejectedAttrs.length) {
  //         isRejectBtnEnabled.value = true
  //       } else {
  //         isRejectBtnEnabled.value = false
  //       }
  //     })
  //     return { isRejectBtnEnabled, rejectedAttrs }
  //   }

  //   if (props.docType == 'result') {
  //     const { isRejectBtnEnabled, rejectedAttrs } = useResultReject()
  //     watch(rejectedAttrs, () => {
  //       if (rejectedAttrs.length) {
  //         isRejectBtnEnabled.value = true
  //       } else {
  //         isRejectBtnEnabled.value = false
  //       }
  //     })
  //     return { isRejectBtnEnabled, rejectedAttrs }
  //   }

  //   if (props.docType == 'memory') {
  //     const { isRejectBtnEnabled, rejectedAttrs } = useMemoryReject()
  //     watch(rejectedAttrs, () => {
  //       if (rejectedAttrs.length) {
  //         isRejectBtnEnabled.value = true
  //       } else {
  //         isRejectBtnEnabled.value = false
  //       }
  //     })
  //     return { isRejectBtnEnabled, rejectedAttrs }
  //   }

  //   if (props.docType == 'receipt') {
  //     const { isRejectBtnEnabled, rejectedAttrs } = useReceiptReject()
  //     watch(rejectedAttrs, () => {
  //       if (rejectedAttrs.length) {
  //         isRejectBtnEnabled.value = true
  //       } else {
  //         isRejectBtnEnabled.value = false
  //       }
  //     })
  //     return { isRejectBtnEnabled, rejectedAttrs }
  //   }
  // },
}
</script>

<style lang="scss" scoped>
svg {
  circle {
    fill: white;
  }
}

button {
  border-radius: 20px;
  width: 512px;
  &:disabled {
    div {
      svg {
        circle {
          fill: black;
        }
      }
    }
  }
}
</style>
